// Autogenerated file
export const bidStateFlagsEnum = {
    None: "None",
    HasPlannedRefuelings: "HasPlannedRefuelings",
    HasUploadedFile: "HasUploadedFile",
    MarkedAsLateByAccept: "MarkedAsLateByAccept",
    CarTemperatureRegimeDeviated: "CarTemperatureRegimeDeviated",
    TrailerTemperatureRegimeDeviated: "TrailerTemperatureRegimeDeviated",
    HasEditedRefuelings: "HasEditedRefuelings",
    HasRefuelingsOutsidePlanByEnterDate: "HasRefuelingsOutsidePlanByEnterDate",
    HasRefuelingsOutsidePlanByLeaveDate: "HasRefuelingsOutsidePlanByLeaveDate",
    HasOdometerMileage: "HasOdometerMileage",
    HasBidCarFuelConsumption: "HasBidCarFuelConsumption",
    QueuedToAnalyzeTollRoadsPassage: "QueuedToAnalyzeTollRoadsPassage",
    CalculatedEstimationDate: "CalculatedEstimationDate",
    MaxNumberOfRefuelingsReached: "MaxNumberOfRefuelingsReached",
    OdometerMileageConsistency: "OdometerMileageConsistency",
    OdometerMileageDeviated: "OdometerMileageDeviated",
    HasAutoCorrectedPoint: "HasAutoCorrectedPoint",
    TrackedEmptyMileageBid: "TrackedEmptyMileageBid",
    CreatedByCloning: "CreatedByCloning",
    IsShippingOrder: "IsShippingOrder",
    WaybillTitleSignRequired: "WaybillTitleSignRequired",
    ImpersonalDealSent: "ImpersonalDealSent",
    WaybillChangeTitleRequired: "WaybillChangeTitleRequired",
    WaybillExternalRevisionsSignRequired: "WaybillExternalRevisionsSignRequired",
    WaybillDeliveryCompletionRequired: "WaybillDeliveryCompletionRequired",
};
export const bidStateFlags = [
    { label: "Без опций", value: "None", intValue: 0 },
    { label: "Есть запланированные заправки", value: "HasPlannedRefuelings", intValue: 1 },
    { label: "В заявку загружен файл(ы)", value: "HasUploadedFile", intValue: 2 },
    { label: "Водитель не принял заявку в течение 1 часа", value: "MarkedAsLateByAccept", intValue: 4 },
    { label: "Отклонение или нет данных температуры по трекеру машины", value: "CarTemperatureRegimeDeviated", intValue: 8 },
    { label: "Отклонение или нет данных температуры по трекеру прицепа", value: "TrailerTemperatureRegimeDeviated", intValue: 16 },
    { label: "Есть измененные заправки", value: "HasEditedRefuelings", intValue: 32 },
    { label: "Есть заправки вне плана заправок", value: "HasRefuelingsOutsidePlanByEnterDate", intValue: 64 },
    { label: "Есть заправки вне плана заправок", value: "HasRefuelingsOutsidePlanByLeaveDate", intValue: 128 },
    { label: "Есть пробег по одометру", value: "HasOdometerMileage", intValue: 512 },
    { label: "Есть расход топлива по заявке", value: "HasBidCarFuelConsumption", intValue: 1024 },
    { label: "В очереди анализа проезда по платным дорогам", value: "QueuedToAnalyzeTollRoadsPassage", intValue: 2048 },
    { label: "Есть расчетное время в рамках заявки.", value: "CalculatedEstimationDate", intValue: 4096 },
    { label: "Достигнуто максимальное количество заправок", value: "MaxNumberOfRefuelingsReached", intValue: 8192 },
    { label: "Пробег по одометру в пределах нормы", value: "OdometerMileageConsistency", intValue: 16384 },
    { label: "Отклонение пробега по одометру", value: "OdometerMileageDeviated", intValue: 32768 },
    { label: "Есть скорректированная точка", value: "HasAutoCorrectedPoint", intValue: 65536 },
    { label: "Отслеживамая порожняя заявка", value: "TrackedEmptyMileageBid", intValue: 131072 },
    { label: "Заявка создана через копирование", value: "CreatedByCloning", intValue: 262144 },
    { label: "Создана из Электронной Заказ-Заявки", value: "IsShippingOrder", intValue: 524288 },
    { label: "Требуется подписание ЭТрН", value: "WaybillTitleSignRequired", intValue: 1048576 },
    { label: "Обезличенная сделка отправлена", value: "ImpersonalDealSent", intValue: 2097152 },
    { label: "Требуется оформление Т8", value: "WaybillChangeTitleRequired", intValue: 4194304 },
    { label: "Исправления ЭТрН — подписать в Контуре", value: "WaybillExternalRevisionsSignRequired", intValue: 8388608 },
    { label: "ЭТрН — продолжить оформление в Контуре", value: "WaybillDeliveryCompletionRequired", intValue: 16777216 },
];
